import { defineStore } from 'pinia'
import boss from 'src/router/boss/index'
import enterprise from 'src/router/enterprise/index'
import { bossgetuser } from '@/api/boss/login'
import { admingetuser } from '@/api/enterprise/login'
import prefixEve from 'src/utils/routeFilter.js'
import { filterRoutesByPermissions } from 'src/utils/routePermission.js'

const prefix = prefixEve.cuttingFiler()

export const useCounterStore = defineStore('counter', {
  state: () => ({
    isSollapse: false,
    count: 0,
    userData: null,
    routerList: [],
    // 动态路由是否已完成注册（与 routerList 长度解耦：无任何权限的用户过滤后为空表，
    // 守卫据此避免把空表当作未注册而重复请求接口）
    routesLoaded: false,
    messNum: 0
  }),
  actions: {
    async setRoleData() {
      const routes = prefix === '/ent' ? enterprise : prefix === '/boss' ? boss : []
      // 先获取当前用户信息（登录后由路由守卫调用一次，写入 userData 供头部/页面使用），
      // 再按 is_super_admin / node_keys 过滤动态路由表
      let userData = null
      try {
        const body = prefix === '/boss' ? await bossgetuser() : await admingetuser()
        userData = body.data
      } catch {
        userData = null
      }
      this.userData = userData
      // 超管展示全部路由；非超管按 node_keys 过滤 rouKey 未命中的菜单节点。
      // 接口失败（userData 为 null）按最严格兜底：nodeKeys 为空，剔除全部带 rouKey 的路由
      this.routerList =
        userData && userData.is_super_admin === true
          ? routes
          : filterRoutesByPermissions(routes, userData && userData.node_keys)
      this.routesLoaded = true
    },
    /**
     * 重置用户态（登录/登出时调用）：清空缓存的用户信息与权限路由表、复位加载标记，
     * 并移除已注册的动态路由，使路由守卫下一次导航时重新拉取 profile 并重建路由。
     * 幂等：重复调用无副作用（removeRoute 对已不存在的 name 静默忽略）。
     * @param {import('vue-router').Router} router 路由实例（以参数传入，避免 store → router → 守卫 → store 循环依赖）
     */
    resetUserState(router) {
      // 先按 name 移除旧动态路由（removeRoute 连带移除整棵子树），再清空路由表
      this.routerList.forEach((route) => {
        if (route.name && router.hasRoute(route.name)) router.removeRoute(route.name)
      })
      this.userData = null
      this.routerList = []
      this.routesLoaded = false
    }
  }
})
